import React, { Component } from 'react'
import PropTypes from 'prop-types'

import CSSModules from 'react-css-modules'
import { Card, CardTitle } from 'react-toolbox/lib/card'
import { Flex } from 'reflexbox'
import { Avatar } from 'react-toolbox/lib/avatar'
import FontIcon from 'react-toolbox/lib/font_icon'

import ApproverCard from './ApproverCard'
import {
  getMonthString,
  getDayNumber,
  getYearString
} from 'helpers/DateUtil'

import theme from './UserApprovedCard.scss'

const UserApprovedCard = (props) => {
  let {
    name,
    roles,
    email,
    image,
    approvalDate
  } = props
  let date = new Date(Date.parse(approvalDate))

  return (
    <ApproverCard
      theme={theme}
      name={name}
      roles={roles}
      email={email}
      image={image}
      approvalDate={`${getMonthString(date)} ${getDayNumber(date)} ${getYearString(date)}`}
      status={'Approved'}
    />
  )
}

UserApprovedCard.propTypes = {
  action: PropTypes.string,
  approvalDate: PropTypes.string,
  name: PropTypes.string.isRequired,
  image: PropTypes.string,
}

export default CSSModules(UserApprovedCard, theme)
